import { useQuery } from '@tanstack/react-query';
import React, { FC, useContext } from 'react';
import { SsoSession } from '../components/services/ssogateway';
import { useSsoGateway } from '../components/services/ssogateway/SsoGatewayProvider';
import { sessionRefreshTime } from './sessionRefreshTime';

const context = React.createContext<{
  ssoSession?: SsoSession;
  status: 'idle' | 'success' | 'error' | 'fetching' | 'paused';
  isLoggedIn?: boolean;
}>({
  status: 'idle',
});

export const SsoSessionContext: FC<{ ssoSession?: SsoSession }> = ({ ssoSession, ...props }) => {
  const ssoGatewayClient = useSsoGateway();
  const { data, fetchStatus } = useQuery(['ssoSession'], () => ssoGatewayClient?.getSession(), {
    enabled: !ssoSession && Boolean(ssoGatewayClient),
    initialData: ssoSession,
    refetchInterval: sessionRefreshTime,
    refetchOnWindowFocus: 'always',
  });

  return (
    <context.Provider
      value={{ ssoSession: data, status: fetchStatus, isLoggedIn: Boolean(data?.userID) }}
      {...props}
    />
  );
};

export const useSsoSessionContext = () => useContext(context);
